import {Component, Event, type EventEmitter, h, Prop} from '@stencil/core';
// import {makeLogger} from '../../../logger/logger';
import type {RedirectionBannerEvent} from '../redirection-banner/RedirectionBannerEvent';

// const {info, warn} = makeLogger({pathToCurrentFile: 'components/widgets/cta-banner/cta-banner.tsx'});

export interface CtaBannerProps {
    fluid?: boolean;
    url?: string;
    label?:string;
    title?:string;
    icon?:string;
    cta?:string;
}

@Component({
  tag: 'uiaas-search-widget-cta-banner',
  styleUrl: 'cta-banner.scss',
  shadow: true
})
export class CtaBanner implements CtaBannerProps{
    @Prop() readonly fluid?: boolean = false;
    @Prop() readonly url?: string = '';
    @Prop() readonly heading: string = '';
    @Prop() readonly label: string = '';
    @Prop() readonly icon?: string = '';
    @Prop() readonly cta?: string = '';



    @Event({
      eventName: 'search:RedirectBannerClick',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      statisticsEventEmitter: EventEmitter<RedirectionBannerEvent>;


    render() {
        return this.label ? (
          <div class={{'cta-banner__container':true, 'cta-banner__container--fluid':this.fluid}}>
            <div
              class="cta-banner__link"
            >
              <div class="cta-banner__content">
                <section class="cta-banner__info-icon" >
                  <se-icon size={this.heading ? 'large' : 'medium'}>{this.icon}</se-icon>
                </section>
                <section class="cta-banner__label-wrapper">
                  {this.heading
                    && <h4 class="cta-banner__heading"> {this.heading} </h4>
                  }
                  <span class={` cta-banner__label ${this.heading ? 'cta-banner__label--boldless' : ''}`}
                    innerHTML={this.label}></span>

                </section>
                <section class="cta-banner__cta">
                  <qds-button
                    href={this.url}
                    target="_blank"
                    onClick={() => this.statisticsEventEmitter.emit({url: this.url})}
                    importance="emphasized"
                    text={this.cta}
                    tabindex="0"
                  >
                  </qds-button
                  >
                </section>

              </div>
            </div>
          </div>
        ) : '';
    }
}
